import { AltText } from "@components/Layout";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import type { JSX, VoidComponent } from "solid-js";
import { ErrorFallbackWrapper } from "./styled";

const ErrorFallback: VoidComponent<{ borderRadius?: JSX.CSSProperties["border-radius"] }> = (props) => {
	const { t } = useI18n();

	return (
		<ErrorFallbackWrapper
			w="100%"
			h="100%"
			alignItems="center"
			justifyContent="center"
			padding="10px"
			style={props.borderRadius ? { "border-radius": props.borderRadius } : {}}
		>
			<AltText textAlign="center">{t("app.error.header")}</AltText>
		</ErrorFallbackWrapper>
	);
};
export default ErrorFallback;
